import { registerAction } from '../../Action'

const LOAD_CSV_ROW_COUNT = 'LOAD_CSV_ROW_COUNT'

const reducer = (state = {}, action) => ({
  ...state,
  csvRowCount: action.payload.count,
})

const loadCSVRowCount = registerAction(LOAD_CSV_ROW_COUNT, { reducer })

export default loadCSVRowCount
